(() => {
 if(window.squishQuickAddBound) return;
 window.squishQuickAddBound=true;
 document.addEventListener('submit',async event=>{
  const form=event.target.closest('[data-sp-quick-add]');
  if(!form)return;
  event.preventDefault();
  if(form.dataset.submitting==='true')return;
  form.dataset.submitting='true';
  const button=form.querySelector('button[type="submit"]');
  const status=form.querySelector('.sp-form-status');
  const label=button.textContent;
  button.disabled=true;button.textContent='Adding…';
  let added=false;
  try{
   const root=window.Shopify?.routes?.root||'/';
   const drawer=document.querySelector('cart-drawer');
   const data=new FormData(form);
   const recipe=form.querySelector('template[data-sd-recipe="'+data.get('bundle_choice')+'"]');
   if(recipe){data.delete('id');data.delete('quantity');recipe.content.querySelectorAll('input').forEach(input=>data.append(input.name,input.value));}
   data.delete('bundle_choice');
   if(drawer){data.append('sections',drawer.getSectionsToRender().map(s=>s.id).join(','));data.append('sections_url',location.pathname);drawer.setActiveElement(button);}
   const response=await fetch(root+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
   const result=await response.json();
   if(!response.ok)throw new Error(result.description||'Could not add this bundle. Please try again.');
   added=true;
   if(drawer)await drawer.renderContents(result);
   if(status)status.textContent='Added to your bag.';
   button.textContent='Added ✓';
   setTimeout(()=>button.textContent=label,1500);
  }catch(error){if(status)status.textContent=added?'Added to your bag. Open your bag to view it.':error.message;button.textContent=label;}
  finally{button.disabled=false;delete form.dataset.submitting;}
 });
})();
